var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.RangePicker,{attrs:{"value":_setup.time,"open":_setup.isOpen,"mode":['year', 'year'],"placeholder":['开始年', '结束年'],"format":"YYYY","size":"large"},on:{"openChange":_setup.handleOpenChange,"panelChange":_setup.handlePanelChange,"change":_setup.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }